export const drawLandmarks = (ctx, landmarks, color = '#00F0FF', radius = 4) => {
  landmarks.forEach(landmark => {
    if (landmark.visibility > 0.5) {
      ctx.beginPath();
      ctx.arc(
        landmark.x * ctx.canvas.width,
        landmark.y * ctx.canvas.height,
        radius,
        0,
        2 * Math.PI
      );
      ctx.fillStyle = color;
      ctx.fill();
      ctx.strokeStyle = color;
      ctx.lineWidth = 2;
      ctx.stroke();
    }
  });
};

export const drawConnections = (ctx, landmarks, connections, color = '#39FF14', lineWidth = 2) => {
  const POSE_CONNECTIONS = [
    [11, 12], [11, 13], [13, 15], [12, 14], [14, 16],
    [11, 23], [12, 24], [23, 24],
    [23, 25], [25, 27], [24, 26], [26, 28],
    [15, 17], [15, 19], [15, 21], [16, 18], [16, 20], [16, 22]
  ];

  ctx.strokeStyle = color;
  ctx.lineWidth = lineWidth;

  POSE_CONNECTIONS.forEach(([startIdx, endIdx]) => {
    const start = landmarks[startIdx];
    const end = landmarks[endIdx];

    if (start && end && start.visibility > 0.5 && end.visibility > 0.5) {
      ctx.beginPath();
      ctx.moveTo(
        start.x * ctx.canvas.width,
        start.y * ctx.canvas.height
      );
      ctx.lineTo(
        end.x * ctx.canvas.width,
        end.y * ctx.canvas.height
      );
      ctx.stroke();
    }
  });
};

export const clearCanvas = (ctx) => {
  ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
};
